import React, { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import ReactLoading from 'react-loading';

import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

import { SessionContext } from "../context/session-context";

const useStyles = makeStyles({
    registerButton: {
        width:200,
    },
    textField:{
      width:'90%',
      '& .MuiOutlinedInput-root':{
        height:36,
      }
    },
    actionButton: {
      color: '#FFFFFF',
      backgroundColor: '#0C4C35',
      '&:hover': {
        color: '#FFFFFF',
        backgroundColor: '#63D764',
      },
      marginTop: 4,
      marginRight: 8,
      padding: '2px 10px 2px 10px'
    },
    cancelButton: {
      color: '#0C4C35',
      border: '1px solid #0C4C35',
      '&:hover': {
        color: '#63D764',
        border: '1px solid #63D764',
      },
      marginTop: 4,
      marginRight: 8,
      padding: '2px 10px 2px 10px'
    },
    divider:{
      marginTop: 10,
      marginBottom: 10,
      height: 2,
    }

});

var handleError = function (err) {
  console.log(err);
  return new Response(JSON.stringify({
    code: 400,
    message: 'Stupid network Error'
  }));
};

export default function DemoDialog(props) {
  const classes = useStyles();
  const {isDemo, onClose} = props;
  const [state, dispatch] = useContext(SessionContext);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState('');
  const [hasNameError, setHasNameError] = useState(false);
  const [hasNameErrorLabel, setHasNameErrorLabel] = useState('');
  const [email, setEmail] = useState('');
  const [hasEmailError, setHasEmailError] = useState(false);
  const [hasEmailErrorLabel, setHasEmailErrorLabel] = useState('');

  const [severity, setSeverity] = useState('success');
  const [msg, setMsg] = useState('');
  const [snackOpen, setSnackOpen] = useState(false);

  const handleSubmit = (event) => {
    setLoading(true);
    let hasError = false;
    if (name.length < 1){ setHasNameError(true); setHasNameErrorLabel('Your name is required'); hasError = true;} else { setHasNameError(false); setHasNameErrorLabel('') }
    if (!isValidEmail(email)){ setHasEmailError(true); setHasEmailErrorLabel('Your email address is required'); hasError = true;} else { setHasEmailError(false); setHasEmailErrorLabel('');}

    if (!hasError){
      console.log("recordClientRegistration called");
      const abortController = new AbortController();
      const request = {   
        username:name,
        email:email
      };

      let mounted = true;
      (async () => {  
          const res = await fetch(process.env.REACT_APP_FIND_API+'/company/demo', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
          }).catch(handleError);
          const data = await res.json();
          if (mounted) {
            if (data.status === "success"){
              dispatch({
                type: "create",
                payload: { userid: parseInt(data.uid), aid: parseInt(data.aid), isActive: true, ident: data.ident }
              });
            } else {
              setSnackOpen(true);
              setSeverity('error')
              setMsg('Failed . Please contact the support team by email on support@mapdata.uk')
            }
            setLoading(false);
          }
          const cleanup = () => {
              mounted = false;
              abortController.abort();
          };
          return cleanup;
      
      })();
    } else {
      setLoading(false);
    }
    event.preventDefault();
  };

  const handleClose = () => {
    setSnackOpen(false);
    onClose();
  }

  function isValidEmail(email) {
    // Ensure input is a string
    if (typeof email !== 'string') return false;
    // Trim whitespace
    email = email.trim();
    // Basic RFC 5322 compliant regex for most valid emails
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return emailRegex.test(email);
}


  return (
      <div>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackOpen} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={severity}>
            {msg}
            </Alert>
        </Snackbar>
        <Dialog open={isDemo} onClose={onClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Start exploring the platform</DialogTitle>
            <DialogContent>
            <Grid container>
              <Grid item xs={12}>
                <Box fontSize={14}>Interested in exploring our platform? Simply share your name and email address and we'll log you in.</Box>
                <Box fontSize={14}>If you have any question please contact the support team on support@mapdata.uk who will be happy to assist.</Box>
              </Grid>
              <Grid item xs={6}>
                <TextField className={classes.textField} error={hasNameError} helperText={hasNameErrorLabel} name="name" label="Your name" size="small" margin="dense" variant="outlined" value={name} onChange={e => setName(e.target.value)} required/> 
              </Grid>
              <Grid item xs={6}></Grid>
              <Grid item xs={8}>
                <TextField type="email" error={hasEmailError} helperText={hasEmailErrorLabel} className={classes.textField} name="email" label="Your email address" size="small" margin="dense" variant="outlined" value={email} onChange={e => setEmail(e.target.value)} required/>
              </Grid>
              <Grid item xs={4}></Grid>

              <Grid item xs={12}><Divider className={classes.divider} /></Grid>
              
              <Grid item xs={12}>
                <Box fontSize={14}>Please note your details will not be shared with any third party. By clicking 'Start Exploring' you are agreeing to our <a href='https://www.mapdata.uk/terms' target='_blank' rel='noopener noreferrer' aria-label="mapdata.uk terms and conditions">Terms and conditions</a>. You get instant access to our training environment, where you can explore the platform and try out selected features and sample products. Some data layers and advanced tools are limited in this demo, but it’s a quick way to see how the system works and what it can do.</Box>
              </Grid>
            </Grid>
            </DialogContent>

            <DialogActions>

              <Button className={classes.cancelButton} onClick={onClose}>
                Cancel
              </Button>

            {loading ? (
                <Box className={classes.actionButton} justifyContent="center"><ReactLoading className={classes.loadingImg} type={"bars"} color={"#63D764"} /></Box>
              ) : (
              <Button className={classes.actionButton} onClick={handleSubmit}>
                Start Exploring
              </Button>
            )}

            </DialogActions>
        </Dialog>
      

    </div>
  );
}